import "../../App.css";
import CircleIcon from "./circleIcons";
import CircleBtn from "./Circlebtn";
import origamiLight from "../../assets/images/origamiLight.png";
import codeLight from "../../assets/images/codeLight.png";
import ideaLight from "../../assets/images/lightbulbLight.png";
import origamiDark from "../../assets/images/origamiDark.png";
import codeDark from "../../assets/images/codeDark.png";
import ideaDark from "../../assets/images/lightbulbDark.png";
import { IsDarkModeProp } from "../common/types";
import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import AnimatedText from "./Animation/AnimatedText";
import Parallax from "./Parallax";

//Export the CircleIcon, origami, code and idea
export const OrigamiIcon = React.memo(({ isDarkMode }: IsDarkModeProp) => (
  <CircleIcon
    $circleBgSize="48px"
    $imageUrl={isDarkMode ? origamiDark : origamiLight}
    $imgSize="60%"
  />
));

export const CodeIcon = React.memo(({ isDarkMode }: IsDarkModeProp) => (
  <CircleIcon
    $circleBgSize="48px"
    $imageUrl={isDarkMode ? codeDark : codeLight}
    $imgSize="60%"
  />
));

export const IdeaIcon = React.memo(({ isDarkMode }: IsDarkModeProp) => (
  <CircleIcon
    $circleBgSize="48px"
    $imageUrl={isDarkMode ? ideaDark : ideaLight}
    $imgSize="60%"
  />
));

const IntroTextStyle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .tiny {
    display: block;
    font-weight: 200;
    font-size: 18px;
  }
  .nameFont {
    font-weight: 700;
    font-size: 28px;
    margin: 0.5rem 0 1rem 0;
    display: inline-block;
  }
  .shadowBox {
    background-color: ${({ theme }) => theme.skillSetBg};
    font-weight: 300;
    width: 170px;
    height: 32px;
    box-shadow: 4px -4px ${({ theme }) => theme.shadowColor};
    border: 1px solid ${({ theme }) => theme.text};
    margin-bottom: 7rem;
    padding-left: 5px;
    display: flex;
    justify-content: start;
    align-items: center;
  }
  .inpirationTxt {
    font-weight: 200;
  }
`;

export function IntroText() {
  return (
    <>
      <IntroTextStyle>
        <div>
          <span className="tiny">Hello, I'm</span>
          <span className="nameFont">John Wandera</span>
          <div className="shadowBox">Backend Engineer</div>
        </div>

        <p className="inpirationTxt">
          I build and maintain powerful backend systems <br />
          that bring digital products to life.
        </p>
      </IntroTextStyle>
    </>
  );
}

const TextAndButtonStyle = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  // border: 1px solid black;
  margin-bottom: 1rem;

  .textDiv {
    // border: 1px solid red;
  }

  @media (max-width: 768px) {
    margin: 1rem 0;

    .textDiv {
      display: flex;
      justify-content: center;
      width: 100%;
      text-align: center;
      margin-bottom: 1rem;
    }
  }
`;

export function TextAndButton() {
  const navigate = useNavigate();
  const phrase =
    "My strength lies in building robust backend logic, secure APIs, and server-side features that drive real-world applications.";
  const handleClick = () => {
    navigate("/about");
  };
  return (
    <TextAndButtonStyle>
      <Parallax offset={30}>
        <div className="textDiv">
          <AnimatedText text={phrase} className="lightText" />
        </div>
      </Parallax>
      <Parallax offset={30} borderRadius="50%">
        <CircleBtn
          $text="About me"
          onClick={handleClick}
          $size="140px"
          $magneticBorderRadius="50%"
        />
      </Parallax>
    </TextAndButtonStyle>
  );
}
